import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import type { IWeekBlocks } from '@/types/block';

import { useAppDispatch, useShowAvailableShifts } from '@/hooks';
import { clearAvailableShifts, getAvailableShifts } from '@/store/slices/scheduleSlice';
import { ToggleSwitch } from '@/components/common';
import { flex } from '@/styles/theme';
import { SIDEBAR_DELAY } from '@/config/variables';

const ToggleAvailableShifts = ({ weekBlocks }: { weekBlocks: IWeekBlocks }): React.ReactElement => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { isShowAvailableShifts, toggleShowAvailableShifts } = useShowAvailableShifts();

  useEffect(() => {
    if (isShowAvailableShifts) {
      const promise = dispatch(getAvailableShifts(weekBlocks));

      return () => {
        promise.abort();
      };
    } else {
      dispatch(clearAvailableShifts());
    }

    return;
  }, [dispatch, isShowAvailableShifts, weekBlocks]);

  return (
    <Row>
      <AvailableShiftsLabel>{t`mySchedule.leftPanel.labelAvailableShifts`}</AvailableShiftsLabel>
      <ToggleSwitch
        name="toggle-available-shifts"
        onChange={toggleShowAvailableShifts}
        checked={isShowAvailableShifts}
      />
    </Row>
  );
};

export { ToggleAvailableShifts };

const Row = styled.div.attrs({
  className: `${flex.row} justify-content-between mt-1 mb-2 flex-wrap`,
})``;

const AvailableShiftsLabel = styled.div`
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  transition: width ${SIDEBAR_DELAY}ms ease-in-out, opacity ${SIDEBAR_DELAY}ms ease-in-out;

  .collapsed & {
    width: 0;
    opacity: 0;
  }
`;
